export function embedOverlay() {
	const videoContainers = document.querySelectorAll('.farlo-ui-video');

	videoContainers.forEach((videoContainer) => {
		const overlay = videoContainer.querySelector('.farlo-ui-video__overlay');
		const iframe = videoContainer.querySelector('.farlo-ui-video__iframe');
		if (!overlay || !iframe) {
			return;
		}

		overlay.addEventListener('click', () => {
			const base = iframe.getAttribute('data-src');
			if (!base) {
				return;
			}

			overlay.style.display = 'none';
			videoContainer.classList.add('is-playing');

			const src = base + (base.includes('?') ? '&' : '?') + 'autoplay=1&playsinline=1';

			const fresh = document.createElement('iframe');
			fresh.className = iframe.className;
			fresh.width = iframe.width || '100%';
			fresh.height = iframe.height || '600';
			fresh.setAttribute('frameborder', '0');
			fresh.setAttribute('allowfullscreen', '');
			fresh.setAttribute('allow', 'autoplay; encrypted-media; accelerometer; clipboard-write; gyroscope; picture-in-picture; web-share');
			fresh.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
			fresh.style.display = 'block';
			fresh.src = src;

			iframe.replaceWith(fresh);
		}, { passive: true });
	});
}
